import { VehicleStatus } from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";
import { VehicleRelatedDto } from "@1games-ru/region-shared/dist/types/vehicle/vehicle-b";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import clsx from "clsx";
import VehicleMpProvider from "@/core/data-provider/data-mp/vehicle/vehicle-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { UserIcon } from "@/shared/icons";
import { Tabs } from "@/shared/ui";
import VehicleCardButtonDepricated from "@/shared/widgets/VehicleCardButtonDepricated";
import PlayerMenuContent from "@/domains/playerMenu/components/PlayerMenuContent";
import PlayerMenuContentProgress from "@/domains/playerMenu/components/PlayerMenuContentProgress";
import PlayerMenuContentTitle from "@/domains/playerMenu/components/PlayerMenuContentTitle";

enum Tab {
  All = "All",
  Owner = "Owner",
  Shared = "Shared",
  Rent = "Rent",
}

export default function PlayerMenuCharacterVehicleContainer() {
  const { t } = useTranslation("playerMenu");
  const [vehicles, setVehicles] = useState<VehicleRelatedDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currTab, setCurrTab] = useState<Tab>(Tab.All);

  const tabs = useMemo(
    () => [
      { value: Tab.All, label: t(`playerMenu.tab.Vehicle${Tab.All}`) },
      { value: Tab.Owner, label: t(`playerMenu.tab.Vehicle${Tab.Owner}`) },
      { value: Tab.Shared, label: t(`playerMenu.tab.Vehicle${Tab.Shared}`) },
      { value: Tab.Rent, label: t(`playerMenu.tab.Vehicle${Tab.Rent}`) },
    ],
    [],
  );

  const getVehilcle = useCallback(async () => {
    const response = await VehicleMpProvider.getVehiclesRelated();

    if (response instanceof RpcMpProviderFailedResponse) {
      toast.error("Не удалось загрузить список транспорта");
      console.log("VehicleMpProvider.getVehiclesRelated()", response);
      return;
    }

    setVehicles(response.data);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    getVehilcle();
  }, []);

  const listVehicles = useMemo(() => {
    switch (currTab) {
      case Tab.Owner:
        return vehicles.filter((item) => item.relation.isOwner);
      case Tab.Shared:
        return vehicles.filter((item) => item.relation.isShared);
      case Tab.Rent:
        return [];
      default:
        return vehicles;
    }
  }, [currTab, vehicles]);

  const header = (
    <div>
      <PlayerMenuContentTitle>{t("playerMenu.tabTitle.Vehicle")}</PlayerMenuContentTitle>
      <Tabs tabs={tabs} value={currTab} onClick={(value) => setCurrTab(value as Tab)} />
    </div>
  );

  return (
    <PlayerMenuContent header={header}>
      {isLoading ? (
        <PlayerMenuContentProgress />
      ) : (
        <div className="flex flex-wrap gap-5">
          {listVehicles.length > 0 && (
            <>
              {vehicles.map((item) => (
                <VehicleCardButtonDepricated
                  key={item.vehicleId}
                  full
                  model={item.model}
                  name={item.name}
                  status={item.status}
                  plateNumber={item.plateNumber}
                  className="w-[15.25rem] h-[17.5rem]"
                >
                  {item.status !== VehicleStatus.Pending && (
                    <div
                      className={clsx(
                        "z-[3] absolute h-[1.625rem] left-5 bottom-20 text-10 leading-2.5 font-bold uppercase z-1",
                        "bg-gradient-to-r from-dark-700/20 to-[#D73434]/20 px-2.5 rounded-[0.375rem] backdrop-blur-[2px]",
                        "flex items-center",
                      )}
                    >
                      {t(`estate.vehicles.status.${item.status.toLowerCase()}`)}
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <UserIcon size={12} className="text-white/50" />
                    <div className="text-14 font-bold">{item.owner.content.name}</div>
                  </div>
                </VehicleCardButtonDepricated>
              ))}
            </>
          )}
        </div>
      )}
    </PlayerMenuContent>
  );
}
